/** @jsx jsx */

import styled from '@emotion/styled'
import tw from 'twin.macro'

export const BadgeStyle = styled.span`
  ${tw`
    inline-flex
    items-center
    px-3
    py-0.5
    rounded-full
    text-xs
    md:text-sm
    font-medium
    leading-5
    bg-indigo-600
    text-white
  `}
`

// @ts-ignore
export const Badge = styled(BadgeStyle)(({ hasHover }) => [hasHover && tw`hover:bg-indigo-500`])
